import { useMemo } from "react";
import { ControlPosition } from "react-draggable";
import { editorGrid } from "../editor.constants";
import { CanvasPositionMap } from "../types/canvas.types";

type GridPositions = Record<string, ControlPosition>;

export function useGridPositions(positions: CanvasPositionMap) {
  const gridPositionEntries = useMemo(
    () =>
      Object.entries(positions).reduce<GridPositions>(
        (acc, [nodeId, position]) => {
          const x = position.x * editorGrid.x;
          const y = position.y * editorGrid.y;
          return Object.assign(acc, { [nodeId]: { x, y } });
        },
        {}
      ),
    [positions]
  );

  return gridPositionEntries;
}
